module.exports = __webpack_public_path__ + "img/gmc.4535ef17.png";